import { useState, useEffect, useCallback } from "react";

import api from "../../../../api/api";
import { getCaseId } from "../../../../Utils/helper";

const useTabsData = () => {
  const [pageSlots, setPageSlots] = useState([]);
  const [unsortedCount, setUnsortedCount] = useState(0);
  const [allCount, setAllCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const currentCaseId = getCaseId();

  const fetchTabsData = useCallback(
    async (additionalParams = {}) => {
      if (!currentCaseId) return;

      setLoading(true);
      setError(null);
      try {
        const response = await api.get("/api/doc-page/doc-page-api-viewset/", {
          params: {
            case_id: currentCaseId || "",
            ...additionalParams, // Spread additional parameters
          },
        });

        if (response.status === 200) {
          setPageSlots(response.data.data || []);
          setUnsortedCount(response.data.unsorted_count || 0);
          setAllCount(response.data.all_count || 0);
        }
      } catch (err) {
        console.error("Error fetching tabs data:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    },
    [currentCaseId]
  );

  // Auto-fetch when dependencies change
  useEffect(() => {
    fetchTabsData();
  }, [fetchTabsData]);

  // Manual refetch function with additional parameters
  const refetch = useCallback(
    (additionalParams = {}) => {
      fetchTabsData(additionalParams);
    },
    [fetchTabsData]
  );

  return {
    pageSlots,
    unsortedCount,
    allCount,
    loading,
    error,
    refetch,
  };
};

export default useTabsData;
